(function () {
    'use strict';

    angular
        .module('app')
        .factory('favoritesService', favoritesService);

    favoritesService.$inject = ['$http', '$q', '$localStorage', '$timeout', 'breadCrumbService', 'loginService'];

    function favoritesService($http, $q, $localStorage, $timeout, breadCrumbService, loginService) {
        var service = {
            currentItem: {},
            getDefinitions: getDefinitions,
            getData: getData,
            definitions: [],
            currentDefinitions: [],
            previous: previous,
            next: next,
            currentIndex: 0,
            animationClass: "",
            close: close,
            gotoPage: gotoPage,
            getCount: getCount,
            addFavoriteList: addFavoriteList,
            editFavoriteList: editFavoriteList,
            deleteFavoriteList: deleteFavoriteList,
            addItemsFavorite: addItemsFavorite,
            deleteItemsFavorite: deleteItemsFavorite,
            resetActive: resetActive
        };
        var dataRequest = {};
        var recordCount = 0;
        return service;

        function getDefinitions(force) {
            var deferred = $q.defer();
            if (service.definitions.length == 0 || force) {
                var request = $http.get("../Synergis.WebApi/Api/favorites/definitions").then(function (response) {
                    angular.forEach(response.data, function (item, index) {
                        item.active = false;
                        item.editEnabled = false;

                        // item.name = item.name + " (" + item.count + ")"; // Count

                    });
                    service.definitions = response.data;
                    service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
                    if (service.onRefresh) {
                        service.onRefresh(response.data);
                    }
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
            }
            else {
                deferred.resolve(service.definitions);
            }
            
            return deferred.promise;
        }

        function getData(skip, take, totalRecords, sort, sortDirection, countOperation, resultType, columns) {
            
            //get current item from local storage if it doesn't exist
            if (Object.keys(service.currentItem).length == 0) {
                service.currentItem = $localStorage.userSettings["favoriteServiceItem"];
            }
            service.currentItem.take = take;
            service.currentItem.skip = skip;
            service.currentItem.ResultType = resultType;
            service.currentItem.Columns = columns;
            service.currentItem.Sort = { SortField: sort, SortOrder: sortDirection }
            $localStorage.userSettings["favoriteServiceItem"] = service.currentItem;

            //Breadcrumb
            
            if (service.currentItem.name.toUpperCase() != "URL NAVIGATION LIST") {
                breadCrumbService.details = service.currentItem.name;
                breadCrumbService.category = loginService.resourceStrings["FAVORITES"];
            }
            else {
                breadCrumbService.details = loginService.resourceStrings["URL_NAVIGATION_LIST"];
                breadCrumbService.category = "";
            }
            breadCrumbService.node = service.currentItem;
            dataRequest = $q.defer();
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            var request = $http({
                url: '../Synergis.WebApi/Api/favorites/documents',
                method: 'POST',
                data: JSON.stringify(service.currentItem),
                responseType: responseType,
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                dataRequest.resolve(response);
            }, function (error) {
                dataRequest.reject(error);
            });

            return { promise: dataRequest.promise };
        };

        function getCount() {
            var deferred = $q.defer();
            dataRequest.promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            })
            return deferred.promise;
        }

        function gotoPage(pageNumber) {
            if (service.currentIndex < pageNumber) {
                service.animationClass = "widget-right";
            }
            else {
                service.animationClass = "widget-left";
            }
            service.currentIndex = pageNumber * 4;
            service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
        }

        function next() {
            service.animationClass = "widget-right";
            service.currentIndex = service.currentIndex + 4;
            service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
        }

        function previous() {
            service.animationClass = "widget-left";
            service.currentIndex = service.currentIndex - 4;
            service.currentDefinitions = service.definitions.slice(service.currentIndex, service.currentIndex + 4);
        }

        function close() {
            service.currentIndex = 0;
            service.currentDefinitions = [];
            service.definitions = [];
        }

        function resetActive() {
            angular.forEach(service.definitions, function (item) {
                item.active = false;
            });
        }

        function addFavoriteList(name, comment) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Favorites/FavoriteList';
            url = url.concat("/" + encodeURIComponent(name) + "/" + encodeURIComponent(comment));
            $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(""),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function editFavoriteList(id, name, comment) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Favorites/FavoriteList';
            url = url.concat("/" + encodeURIComponent(id));
            var favorite = { name: name, comment: comment };
            $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(favorite),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteFavoriteList(id) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Favorites/FavoriteList';
            url = url.concat("/" + encodeURIComponent(id));
            $http({
                url: url,
                method: 'DELETE',
                data: JSON.stringify(""),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function addItemsFavorite(id, rows) {
            var containerItemModelList = buildContainerItemModelList(rows);
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Favorites/Items';
            url = url.concat("/" + encodeURIComponent(id));
            $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(containerItemModelList),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteItemsFavorite(id, rows) {           
            service.loading = true;
            var containerItemModelList = buildContainerItemModelList(rows);
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Favorites/Items';
            url = url.concat("/" + id);
            $http({
                url: url,
                method: 'DELETE',
                data: JSON.stringify(containerItemModelList),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function buildContainerItemModelList(rows) {
            // Item info comes directly from the grid.
            var containerItemModelList = [];
            angular.forEach(rows, function (item) {
                var tableNumber = item.SCHEMA_S_SRCDB;
                var fileId = item.SCHEMA_S_FILEID;
                var majRev = item.SCHEMA_S_MAJREV;
                var minRev = item.SCHEMA_S_MINREV;
                var containerItemModel = { srcdb: tableNumber, objectId: fileId, majRev: majRev, minRev: minRev };
                containerItemModelList.push(containerItemModel);
            });
            return containerItemModelList;
        }

    }
})();